import sendLocalRequest from "./sendLocalRequest";
import {UI_CONFIG} from "../../config";

export const getLastProvisionedMachines = (auth_token, exclusive_start_key, count) => {
    return  new Promise( (resolve, reject) => {
        const body = {
            "count": UI_CONFIG.PROVISIONED_MACHINES_PER_PAGE,
        }
        if (count !== null && count !== undefined) {
            body["count"] = count;
        }
        if (exclusive_start_key !== null && exclusive_start_key !== undefined) {
            body["exclusive_start_key"] = exclusive_start_key
        }

        let url = "machines/last_provisioned";

        sendLocalRequest(url, "POST", auth_token, body).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
